import { render, staticRenderFns } from "./viewClassInfo.vue?vue&type=template&id=4752d9bc&scoped=true"
import script from "./viewClassInfo.vue?vue&type=script&lang=js"
export * from "./viewClassInfo.vue?vue&type=script&lang=js"
import style0 from "./viewClassInfo.vue?vue&type=style&index=0&id=4752d9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752d9bc",
  null
  
)

export default component.exports